import { render, staticRenderFns } from "./dashboardTeam.vue?vue&type=template&id=5e8bf9fb"
import script from "./dashboardTeam.vue?vue&type=script&lang=js"
export * from "./dashboardTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports